export const VENUE_UUID = "d0c02776-7a53-4787-a5f4-8b50be76b848"